import { InputDatePicker } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { DEFAULT_CURRENCY } from '@shared/constants'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Typography
} from 'antd'
import dayjs from 'dayjs'
import { Trash } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

const { Title } = Typography

export const LastDamages = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()

  const { lastDamagesProps, noDamagesProps } = formProps(t)

  const noDamages = Form.useWatch(noDamagesProps.name, { preserve: true })

  return (
    <>
      <Title level={5}>{t('last_3_years_damages')}</Title>

      <Form.Item name={noDamagesProps.name} valuePropName="checked">
        <Checkbox>{noDamagesProps.label}</Checkbox>
      </Form.Item>

      {!noDamages && (
        <Form.List name={lastDamagesProps.name}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <Row key={key} gutter={[12, 0]} align="middle">
                  <Col xs={24} lg={5}>
                    <Form.Item
                      name={[name, 'date']}
                      label={t('date')}
                      rules={[required]}
                    >
                      <InputDatePicker maxDate={dayjs()} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={7}>
                    <Form.Item
                      name={[name, 'description']}
                      label={t('description')}
                      rules={[required]}
                    >
                      <Input placeholder={t('description')} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={5}>
                    <Form.Item
                      name={[name, 'amount']}
                      label={t('amount')}
                      rules={[required]}
                    >
                      <InputNumber
                        className="w-full"
                        min={0}
                        placeholder={t('amount')}
                        suffix={DEFAULT_CURRENCY}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={20} lg={5}>
                    <Form.Item name={[name, 'insurer']} label={t('insurer')}>
                      <Input placeholder={t('insurer')} />
                    </Form.Item>
                  </Col>

                  <Col xs={4} lg={2}>
                    <Form.Item label=" ">
                      <Button
                        type="text"
                        danger
                        icon={<Trash size={16} />}
                        onClick={() => remove(name)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}

              <Button type="dashed" block onClick={() => add()}>
                + {t('add_damage')}
              </Button>
            </>
          )}
        </Form.List>
      )}
    </>
  )
}
